import React, { useState } from "react";
import clsx from "clsx";
import { Link } from "react-router-dom";

import { makeStyles } from "@mui/styles";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import FaceIcon from "@mui/icons-material/Face";
import PhoneIcon from '@mui/icons-material/Phone';
import CreateIcon from '@mui/icons-material/Create';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import LocalFloristIcon from '@mui/icons-material/LocalFlorist';

type Anchor = 'top' | 'left' | 'bottom' | 'right';

type WhatStateResult = {
  top: boolean,
  left: boolean,
  bottom: boolean,
  right: boolean,
}

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
  SideBarBlock: {
    padding: "25px",
    position: "fixed",
  },
  menuButton: {
    cursor: "pointer",
  },
  link: {
    color: "inherit",
    textDecoration: "inherit",
  },
});

const SideBar = () => {
  const classes = useStyles();

  const [state, setState] = useState<WhatStateResult>({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor: Anchor, open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const list = (anchor: Anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === "top" || anchor === "bottom",
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        <Link to="/" className={classes.link} >
          <ListItem component="div" key="AboutUs">
            <ListItemIcon>
              <FaceIcon />
            </ListItemIcon>
            <ListItemText primary="O NAS" />
          </ListItem>
        </Link>
        <Link to="/plantNursery" className={classes.link} >
          <ListItem component="div" key="plantNursery">
            <ListItemIcon>
              <HomeWorkIcon />
            </ListItemIcon>
            <ListItemText primary="SZKÓŁKA ROŚLIN" />
          </ListItem>
        </Link>
        <Link to="/projects" className={classes.link} >
          <ListItem component="div" key="projects">
            <ListItemIcon>
              <CreateIcon />
            </ListItemIcon>
            <ListItemText primary="PROJEKTY" />
          </ListItem>
        </Link>
        <Link to="/gardenCare" className={classes.link} >
          <ListItem component="div" key="gardenCare">
            <ListItemIcon>
              <LocalFloristIcon />
            </ListItemIcon>
            <ListItemText primary="PIELĘGNACJA OGRODÓW" />
          </ListItem>
        </Link>
        <Link to="/contact" className={classes.link} >
          <ListItem component="div" key="contact">
            <ListItemIcon>
              <PhoneIcon />
            </ListItemIcon>
            <ListItemText primary="KONTAKT" />
          </ListItem>
        </Link>
      </List>
    </div>
  );

  return (
    <div className={classes.SideBarBlock}>
      <React.Fragment key={"left"}>
        <Button
          onClick={toggleDrawer("left", true)}
          className={classes.menuButton}
        >
          <MenuIcon fontSize="large" />
        </Button>
        <Drawer
          anchor={"left"}
          open={state["left"]}
          onClose={toggleDrawer("left", false)}
        >
          {list("left")}
        </Drawer>
      </React.Fragment>
    </div>
  );
};

export default SideBar;
